import React from "react";
import { ImageListItem, ImageListItemBar, Rating, styled } from "@mui/material";
// import { StarRounded } from "@mui/icons-material";
import { FaStar } from "react-icons/fa";

export default function RatingItem({children,key,value,size="small"}){

  const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
      color: '#E3031F',
    },
    '& .MuiRating-iconHover': {
      color: '#ff3d47',
    },
  });

  
    return(
      <StyledRating key={key} precision={0.5}  name="half-rating-read" 
          icon={<FaStar fontSize={size} sx={{ color: "#E3031F" }} />}
          emptyIcon={<FaStar fontSize={size} style={{ opacity: 0.55 }} />}
           value={value} readOnly size={size} />
    )
  }